import { UntypedFormArray } from '@angular/forms';
import { ItemFactory } from '../interfaces/form-controls';

// Ensures that the form array has the specified number of controls, using the provided control to add new controls
export function fixControlsForFormArray(
  formArray: UntypedFormArray,
  controlFactory: ItemFactory,
  length: number,
): void {
  // Remove excess controls
  while (formArray.length > length) {
    formArray.removeAt(formArray.length - 1);
  }
  // Add missing controls
  while (formArray.length < length) {
    formArray.push(controlFactory());
  }
}
